import { Suspense, lazy } from 'react';

const PeopleOverview = lazy(() => import('../components/People/PeopleOverview'));

const PeopleOverviewLazy: React.FC = () => {
    return <Suspense><PeopleOverview/></Suspense>;
}

export default PeopleOverviewLazy;
